import { IconNames } from '@blueprintjs/icons';
import { DropdownMenu } from '@strata/react-dropdown-menu';
import { Icon } from '@strata/react-status-icons';
import * as PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { AppRoutes } from 'services/routes';

const backToDestination = {
    route: AppRoutes.referralsList,
    text: 'Referrals',
};

export const ReferralRowMenu = ({ treatmentId = undefined, payerId = undefined }) => {
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);

    const dropdownMenuOptions = [
        {
            text: 'Go to Patient Treatment',
            disabled: !treatmentId || !payerId,
            onItemClick: () =>
                navigate(AppRoutes.treatmentDetails(payerId, treatmentId), {
                    state: {
                        backToDestination,
                    },
                }),
        },
    ];

    return (
        <DropdownMenu
            isOpen={showDropdown}
            menuItemArray={dropdownMenuOptions}
            onInteraction={(nextOpenState, e) => {
                e?.stopPropagation();
                setShowDropdown(nextOpenState);
            }}
        >
            <Icon
                icon={IconNames.MORE}
                intent={Icon.Intent.SECONDARY}
                title="Referral Menu"
                className="sds_referral-grid__row-menu-button"
            />
        </DropdownMenu>
    );
};

ReferralRowMenu.propTypes = {
    treatmentId: PropTypes.string,
    payerId: PropTypes.string,
};
